/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFeedbackGetResponseFeedback } from "../../funcs/llmFeedbackGetResponseFeedback.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetResponseFeedbackRequest$inboundSchema,
};

export const tool$llmFeedbackGetResponseFeedback: ToolDefinition<typeof args> =
  {
    name: "llm-feedback-get-response-feedback",
    description: `Retrieve feedback by response ID

Retrieves the existing feedback rating and description for a specific agent response.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await llmFeedbackGetResponseFeedback(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
